(function () {
  'use strict';

  var initializedRoots = (typeof WeakSet !== 'undefined') ? new WeakSet() : null;
  var initializedFallback = [];

  function alreadyInit(root) {
    if (initializedRoots) return initializedRoots.has(root);
    return initializedFallback.indexOf(root) !== -1;
  }
  function markInit(root) {
    if (initializedRoots) { initializedRoots.add(root); }
    else { initializedFallback.push(root); }
  }

  function initReviewCarousel(root) {
    if (alreadyInit(root)) return;

    var viewport = root.querySelector('.upk-rev-viewport');
    var track = root.querySelector('.upk-rev-track');
    if (!viewport || !track) return;

    var cards = Array.prototype.slice.call(track.children);
    if (cards.length <= 1) return;

    markInit(root);

    var intervalMs = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 5000;
    var timer = null;
    var paused = false;
    var programmatic = false;

    function step() {
      var card = cards[0];
      var rect = card.getBoundingClientRect();
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return rect.width + gap;
    }

    function atEnd() {
      return viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 2;
    }

    function next() {
      programmatic = true;
      if (atEnd()) {
        viewport.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        viewport.scrollBy({ left: step(), behavior: 'smooth' });
      }
      clearTimeout(viewport._upkProgTimer);
      viewport._upkProgTimer = setTimeout(function () { programmatic = false; }, 700);
    }

    function start() {
      stop();
      timer = setInterval(function () {
        if (!paused) next();
      }, intervalMs);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    root.addEventListener('touchend', function () {
      setTimeout(function () { paused = false; }, 2500);
    }, { passive: true });
    viewport.addEventListener('scroll', function () {
      if (programmatic) return;
      paused = true;
      clearTimeout(viewport._upkResumeTimer);
      viewport._upkResumeTimer = setTimeout(function () { paused = false; }, 2500);
    }, { passive: true });

    /* P7.5: autoplay runs only while the carousel is on screen. The observer starts the interval when the carousel comes into view
       and stops it when it leaves (before, the interval ran for the life of the page). The interval, the pause on hover, touch and
       scroll, and the card layout are unchanged. */
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) { if (entries[i].isIntersecting) start(); else stop(); }
      }, { threshold: 0.1 });
      io.observe(root);
    } else {
      start();
    }

    document.addEventListener('shopify:section:unload', function (e) {
      if (e.target.contains(root)) { stop(); if (io) io.disconnect(); }
    });
  }

  function findJudgemeWriteReviewButton(container) {
    // Legacy Review Widget's write-review link
    var legacy = container.querySelector('.jdgm-write-rev-link');
    if (legacy) return legacy;

    var candidates = container.querySelectorAll('.jm-action-buttons__button, button, a');
    for (var i = 0; i < candidates.length; i++) {
      var text = (candidates[i].textContent || '').trim().toLowerCase();
      if (text === 'write a review' || text === 'write a store review') {
        return candidates[i];
      }
    }
    return null;
  }

  // PRODUCT-scoped: opens the review form for the exact product on the page.
  function openJudgemeForm() {
    var jdgmSection = document.getElementById('judgeme_product_reviews');
    if (!jdgmSection) return;
    var attempts = 0;
    var tryClick = function () {
      attempts += 1;
      var realBtn = findJudgemeWriteReviewButton(jdgmSection);
      if (realBtn) {
        realBtn.click();
      } else if (attempts < 20) {
        setTimeout(tryClick, 250);
      }
    };
    setTimeout(tryClick, 400);
  }

  // SHOP-scoped: opens Judge.me's store-level review form (Happy Customers
  // Widget's "Write a Store Review" flow), never tied to any one product.
  // Note: the Happy Customers Widget is a Judge.me Awesome-plan feature; on
  // stores without that plan this container may not populate a real button,
  // in which case this intentionally does nothing rather than falling back
  // to opening a product-specific form (which would be the wrong behavior).
  function openJudgemeShopForm() {
    var jdgmSection = document.getElementById('judgeme_shop_reviews');
    if (!jdgmSection) return;
    var attempts = 0;
    var tryClick = function () {
      attempts += 1;
      var candidates = jdgmSection.querySelectorAll('.jm-action-buttons__button, button, a, [class*="store-review"], [class*="write"]');
      var found = null;
      for (var i = 0; i < candidates.length; i++) {
        var text = (candidates[i].textContent || '').trim().toLowerCase();
        if (text.indexOf('store review') !== -1 || text.indexOf('shop review') !== -1 || text === 'write a review') {
          found = candidates[i];
          break;
        }
      }
      if (found) {
        found.click();
      } else if (attempts < 20) {
        setTimeout(tryClick, 250);
      }
    };
    setTimeout(tryClick, 400);
  }

  function initWriteReviewCta() {
    document.addEventListener('click', function (e) {
      var productBtn = e.target.closest ? e.target.closest('.upk-write-review-cta') : null;
      if (productBtn) {
        openJudgemeForm();
        return;
      }
      var shopBtn = e.target.closest ? e.target.closest('.upk-write-shop-review-cta') : null;
      if (shopBtn) {
        openJudgemeShopForm();
      }
    });
  }

  initWriteReviewCta();

  // NOTE: the live Judge.me API sync + render (fetch reviews, rebuild the
  // .upk-rev DOM) previously duplicated here has been removed. It only ever
  // targeted elements matching `.upk-rev[data-jdgm-live="true"]`, but
  // sections/upk-reviews.liquid never sets a `data-jdgm-live` attribute, it
  // sets `data-upk-live="true"` instead, which assets/upk-reviews-topup.js
  // already handles as the single active implementation. This block ran on
  // every page load (DOMContentLoaded, window load, and a 1.5s timeout) but
  // always matched zero elements, so it was dead weight, not a second live
  // code path. Deleting it changes no visible behavior.

  function initAll() {
    var roots = document.querySelectorAll('.upk-rev[data-autoplay="true"]');
    for (var i = 0; i < roots.length; i++) initReviewCarousel(roots[i]);
  }

  initAll();
  document.addEventListener('DOMContentLoaded', initAll);
  window.addEventListener('load', initAll);
  document.addEventListener('shopify:section:load', initAll);
  setTimeout(initAll, 1500);
})();
